<template>
  <div>
    <template v-for="(item, index) in options">
      <template v-if="values.includes(item[configKey])">
        <el-tag :disable-transitions="true" :key="item[configKey]" :index="index" type="primary">
          {{ item.name }}
        </el-tag>
      </template>
    </template>
  </div>
</template>

<script>
export default {
  name: "DictTag",
  props: {
    options: {
      type: Array,
      default: null,
    },
    value: [Number, String, Array],
    configKey: {
      type: String,
      default: "code"
    }
  },
  mounted() { },
  computed: {
    values() {
      if (this.value !== null && typeof this.value !== 'undefined') {
        return Array.isArray(this.value) ? this.value : [String(this.value)];
      } else {
        return [];
      }
    },
  },
};
</script>
<style scoped>
.el-tag + .el-tag {
  margin-left: 10px;
}
</style>